var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439 435",
    width: 439,
    height: 435,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "why-02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #ffb600 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m293.2 190.2c-9.1 1.2-19.3 10.7-21.9 19.5-2.1 7.3-2.1 23.9 0.6 31.1 0.6 1.6 3.8 6.6 3.7 7.3-0.1 1.1-2.8 4.4-3.5 6.2-2.9 7.4-1.8 14.1-2.1 21.8-11.4 3.6-22.4 9.8-31.2 17.9-2.6 2.5-5.2 6.9-7.7 8.5-5.7 3.7-15.9 5-22.3 7.8l-9.4 25h-41.5l-11.2-25.4c-13-3.7-25.7-8.3-37.2-15.5-5.3-0.3-23.2 11.4-26.8 9.8l-28.3-28.6 10.4-24.9c-6.7-12.2-12.2-25-15.8-38.5l-25.6-10.3 0.2-41.1 25.7-11.7c3.2-13.4 9.2-25.8 15.5-37.9l-10.4-25 28.3-28.6c0.9-0.7 1.6-0.2 2.4 0 7.3 1.6 16.2 8.5 23.8 10 11.9-6.8 24.6-12.1 37.8-15.7l11.2-25.4h41.5l9.9 25.4c13.5 3.5 26.2 9.1 38.5 15.8l24.9-10.4 28.9 29.5-10.4 24.4c3.3 6.9 7.3 13.5 10.1 20.7 1.7 4.3 3.6 14.2 5.4 17.2 2 3.5 21.9 7.8 25.8 11.5v29.6c-12.2 1.2-27.4-1.5-39.3 0zm-120.7-105.2c-75.2 4.3-116.2 90.1-72.6 151.7 39.9 56.6 126.5 52.6 161.1-7.3 38.2-66.3-12.2-148.7-88.5-144.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m284.5 286.2c65.5-6.7 99.3 73.4 49.2 114.9-34 28.2-86.2 13.9-101.8-27.1-14.7-38.9 10.9-83.6 52.6-87.8zm14.8 27.3c1.4-6.3-4.2-13.4-10.5-9.2-3.8 2.4-1.6 6.5-2.9 8.5-0.3 0.5-7.2 3-8.8 4.1-15.9 10.7-11.5 31.8 6.3 38 7.7 2.7 24.8 2.1 23.2 14.2-1.1 8.3-17.9 8.3-23.8 4.3-4.2-2.8-3.8-6.3-6.2-9.2-4.3-5.3-11.8-1.4-11.4 4.8 0.6 8.7 12.4 18.9 21 19.2-2.2 13.7 14.8 13.3 13.1 0 24.2-2.9 28.7-31.9 5-41.2-5.6-2.3-21.7-3.7-23.5-9.7-3.6-11.8 15.3-15.5 22.2-8.1 3.5 3.7 2.7 8.9 10.4 7.8 13.6-2-5.2-25.7-14.1-23.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m295 203.4l106.5 0.2c6.5 1.9 10.8 8 11.4 14.6 1.2 13.5 0.1 26.1-15.9 28-31.5-2-66.3 2.7-97.4 0-17.2-1.4-17.9-14.4-16.6-28.8 0.7-7.2 5.1-12.2 12-14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m283.1 273c-1.2-11.8 1.7-21.8 14.9-22.8 32.9-2.4 69 1.9 102.2 0.1 13.3 2.9 13.9 17.5 12.6 28.8-0.9 8.8-8.3 13.4-16.6 14.1-16 1.5-34.1-1-50.3 0-10.5-8.4-29.9-20.2-43.8-20.2h-19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m401.1 297.3c12.1 2 12.7 18.5 11.7 28-2.1 20.6-28.6 14-42.9 14.9-2.2-16.1-9.5-30.9-20.3-42.9h51.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m401.9 344.4c2.6 0.5 8 5.3 9.2 7.8 2.7 5.4 2.5 20.3 0.2 25.9-1.1 2.4-7.1 8.4-9.4 8.4h-40.2c7.1-12.7 9.5-27.6 9-42.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m221 174.8c5.9 1.3 6.1 11.5-1 12.8-7 1.3-32.9 1-40.4 0.2-4.9-0.5-7.3-1.7-7.7-6.9-1.4-15.3 0.9-32.9 0.2-48.5 1.7-4.2 8.1-5.3 10.9-2 0.3 0.4 1.9 4 1.9 4.3v40.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m122.2 120.6c7.1-1.5 19.8 12.7 11.1 17.6-8.8 5-23.1-15-11.1-17.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m224.4 222.8c7.1-1.5 19.8 12.7 11.1 17.6-8.8 5-23.1-15-11.1-17.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m230.1 120.7c3.8-1 7.8 1.1 8.3 5.1 0.7 5.6-8.7 14.9-14.6 13-9.8-3.1 0.8-16.7 6.3-18.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m127.9 222.9c3.8-1 7.8 1.1 8.3 5.1 0.7 5.6-8.7 14.9-14.6 13-9.8-3.1 0.8-16.7 6.3-18.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m243.9 175c3.3-0.8 13.5-0.8 15.7 1.8 7.3 9.1-9.2 14.1-16.9 9.6-4.1-2.5-3.7-10.3 1.2-11.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m175.8 243.1c14.6-3.3 10.8 27.7-1.4 19.7-3.7-2.5-4.4-18.4 1.3-19.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m177.4 97.9c13.1-1.2 7.8 30-3.8 19.7-2.9-2.5-3.8-18.9 3.8-19.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m99.5 175c5.1-1.1 16.2-1.7 16.9 5.4 0.7 8.4-13.9 9.1-18.7 5.8-4.1-2.8-3.2-10.1 1.8-11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy02);
export default __webpack_public_path__ + "static/media/why-02.bf5f062970ae4d5ad4354b13f1e36ee3.svg";
export { ForwardRef as ReactComponent };